  <!--
   功能名称:千里眼平台(技师)-比一比
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <div class="ranking-wrap">
    <div class="bg"></div>
    <van-tabs v-model="rankingType" type="card" background="transparent" color="#fff" title-active-color="#691BFF">
      <van-tab title="按总钟数排名" :name="1"></van-tab>
      <van-tab title="按点钟数排名" :name="2"></van-tab>
      <van-tab title="按加钟数排名" :name="3"></van-tab>
    </van-tabs>
    <time-select @timeChange="timeChange" :classType="'tech-ranking'"></time-select>
    <div class="ranking-box">
      <div class="title">
        <span>排名</span>
        <span>工号</span>
        <span>{{rankingType==1?'总钟':(rankingType==2?'点钟':'加钟')}}</span>
      </div>
      <ul>
        <li v-for="(item,index) in rankingData" :key="index">
          <span v-bind:style="{'color':index<3?'#FF9500':'#999'}">{{index+1}}</span>
          <div>
            <img class="staffImg" v-bind:style="{'border-color':index==0?'#FFBC4C':(index==1?'#BBC3CB':(index==2?'#DF9166':'#fff'))}" v-lazy="item.staff_img"/>
            <img class="icon" v-if="index<3" :src="isPlace(index)">
            <span>{{item.staff_no}}</span>
          </div>
          <span>{{rankingType==1?item.total_clock:(rankingType==2?item.dot_clock:item.add_clock)}}</span>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import table from '@/api/table'
export default {
  name: 'ranking',
  components: {
    'time-select':() => import('@/components/time-select')
  },
  filters: {},
  mixins: [],
  props: {},
  data () {
    return {
      rankingType:1,
      timeParams:null,
      rankingData:new Array(),
            imageList: [
              'https://img01.yzcdn.cn/vant/apple-1.jpg',
              'https://img01.yzcdn.cn/vant/apple-2.jpg',
            ]
    }
  },
  computed: {
    isPlace:function(){
      return function(index){
        let img='';
        switch(index){
          case 0:
            img=require('@/assets/images/one-icon.png')
            break;
          case 1:
            img=require('@/assets/images/two-icon.png')
            break;
          case 2:
            img=require('@/assets/images/three-icon.png')
        }
        return img
      }
    }
  },
  watch: {
    timeParams:{
      handler(newVal,oldVal){
        let {timeParams} = this
        if(! newVal || ! timeParams){
          return
        }
        if(! ! newVal && ! ! oldVal && newVal.startTime === oldVal.startTime){
          return
        }
        this.rankingList({rankingType:this.rankingType,startTime:this.timeParams.startTime,endTime:this.timeParams.endTime})
      },
      immediate:true,
      deep:true
    },
    rankingType(newVal,oldVal){
      this.rankingList({rankingType:this.rankingType,startTime:this.timeParams.startTime,endTime:this.timeParams.endTime})
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    /* 切换时间段*/
    timeChange(timeParams){
      this.timeParams=timeParams
    },
    rankingList(param){
      table.rankingList(param).then(response=>{
        this.rankingData=response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .ranking-wrap {
    position:relative;
    .bg{
      height: 420px;
      width: 100%;
      position: absolute;
      top: 0;
      background: url("~@/assets/images/achievement-Bg.png") no-repeat top/100%;
      background-position:0 -355px;
    }
    .van-tabs--card{
      padding-top:30px;
      /deep/ .van-tabs__nav--card{
        margin: 0 30px;
      }
    }
    .ranking-box{
      border-radius: 16px;
      position: relative;
      margin: 35px 30px 0;
      padding: 0 30px;
      background:#fff;
      .title{
        display: flex;
        justify-content: space-between;
        font-size: 24px;
        color: #999999;
        line-height:90px;
        span{
          width: 100px;
          text-align: center;
        }
        span:nth-child(2){
          display: inline-block;
          text-align: left;
          width: 270px;
        }

      }
      ul{
        height:calc(100vh - 440px);
        overflow-y: auto;
        li{
          display: flex;
          justify-content: space-between;
          line-height: 90px;
          border-bottom: 1px solid #F0F0F0;
          font-size: 28px;
          color: #333;
          span{
            width: 100px;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          div:nth-child(2){
            width: 270px;
            span{
              text-align: left;
            }
          }
          div{
            position: relative;
            display: flex;
            align-items: center;
            .staffImg{
              width: 52px;
              height: 52px;
              border-radius: 50%;
              margin-right: 13px;
              border: 2px solid #fff;
            }
            .icon{
              position: absolute;
              left: 8px;
              top: 0px;
              width: 40px;
              height: 25px
            }
          }
        }
      }
      ul::-webkit-scrollbar {
        display: none
      }
    }
  }
</style>
